import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { AddressBookSaveComponent } from '../address-book-save/address-book-save.component';
import { SnackbarService } from '@ctsolution/ct-framework';
import { ActivatedRoute, Router } from '@angular/router';
import { AddressBookParameter } from 'src/app/core/classes/address-book.parameter';
import { AddressBookController } from 'src/app/core/controllers/address-book.controller';
import { JwtService } from 'src/app/core/lib/jwt.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef } from "@angular/material/legacy-dialog";

@Component({
  selector: 'app-address-book-detail',
  templateUrl: './address-book-detail.component.html',
  styleUrls: ['./address-book-detail.component.scss']
})
export class AddressBookDetailComponent implements OnInit {

  @ViewChild("form") addressBookSaveComponent: AddressBookSaveComponent | null = null;

  constructor(private snackbar: SnackbarService, private router: Router, private route: ActivatedRoute, private addressBookController: AddressBookController, private jwt: JwtService,@Optional() private matDialogRef : MatLegacyDialogRef<AddressBookDetailComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data?: AddressBookParameter | null) { }

  async ngOnInit() {

    const addressBookEnabled = await this.jwt.getAddressBookEnabled()

    if (addressBookEnabled == false) {

      this.matDialogRef?.close();

    }

  }


  onSubmit() {

    const form = this.addressBookSaveComponent?.form;

    if (!form || !form.valid) return;

    const param: AddressBookParameter = AddressBookParameter.create()

    param
      .setEnabled(form.value.Enabled ?? false)
      .setName(form.value.Name)
      .setShared(form.value.Shared ?? false)
      .setType(form.value.Type)

    if (this.data?.Oid)
      param.setOid(this.data.Oid)


    this.addressBookController
      .save(param)
      .subscribe(() => {

          this.matDialogRef.close();
          this.snackbar.open("Rubrica salvata correttamente!", "X");

      });

  }

}
